import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Jumbotron,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText
} from "reactstrap";
import Post from "../components/Post";
import Butter from "buttercms";
const BUTTER = Butter(process.env.REACT_APP_BUTTER_API_KEY);

class BlogContainer extends Component {
  state = {
    blogPosts: null
  };

  componentDidMount() {
    BUTTER.post.list({ page: 1, page_size: 10 }).then(response => {
      this.setState({
        blogPosts: response.data.data
      });
    });
  }

  render() {
    return (
      <Jumbotron
        className="blog-container"
        style={{ minHeight: window.innerHeight }}
      >
        <ListGroup>
          {this.state.blogPosts
            ? this.state.blogPosts.map(p => (
                <ListGroupItem className="headline-card">
                  <ListGroupItemHeading className="blog-headline">
                    <Link to={`/blog/${p.slug}`}>{p.title} </Link>
                  </ListGroupItemHeading>
                  <p className="meta-text">
                    {new Date(p.published).toString()}
                  </p>
                  <ListGroupItemText>{p.summary}</ListGroupItemText>
                </ListGroupItem>
              ))
            : "Loading ..."}
        </ListGroup>
      </Jumbotron>
    );
  }
}

export default BlogContainer;
